import { useState, useEffect } from 'react';
import { useWeglot } from '../context/WeglotContext';
import { useIonToast } from '@ionic/react';
import { ToastOptions } from '@ionic/core/components';

export function useToaster(): [(options: ToastOptions) => void] {
  const [options, setOptions] = useState<ToastOptions>({});
  const { weglot, language } = useWeglot();
  const [present] = useIonToast();

  useEffect(() => {
    if (options.message) {
      weglot.current?.translate(
        {
          words: [{ t: 1, w: options.message as string }],
          languageTo: language,
        },
        (message: string) => present({ ...options, message }),
      );
    }
  }, [options, language, weglot]);

  return [setOptions];
}
